export const emptyIsoValue = (unit) => {
    switch (unit) {
        case 'minute':
            return 'PT0M';
        case 'year':
            return 'P0Y';
        case 'month':
            return 'P0M';
        case 'day':
            return 'P0D';
        default:
            return 'PT0M';
    }
};

/** Integer (API) -> ISO 8601 duration string, depending on `unit`. */
export const encodeIsoDuration = (n, unit) => {
    const v = Math.max(0, Math.floor(Number(n)));
    if (Number.isNaN(v)) {
        return emptyIsoValue(unit);
    }
    switch (unit) {
        case 'minute':
            return `PT${v}M`;
        case 'year':
            return `P${v}Y`;
        case 'month':
            return `P${v}M`;
        case 'day':
            return `P${v}D`;
        default:
            return String(n);
    }
};

/**
 * @param {unknown} raw — stored value (often ISO string; bare integer still accepted)
 * @param {string} unit
 */
export const decodeIsoDuration = (raw, unit) => {
    if (raw == null || raw === '') return '';
    if (typeof raw === 'number' && !Number.isNaN(raw)) {
        return Math.max(0, Math.floor(raw));
    }
    const s = String(raw).trim();

    if (unit === 'minute') {
        const m1 = s.match(/^PT(\d+)M$/i);
        if (m1) return parseInt(m1[1], 10);
        const m2 = s.match(/T(\d+)M/);
        if (m2) return parseInt(m2[1], 10);
        if (/^\d+$/.test(s)) return parseInt(s, 10);
        return 0;
    }
    if (unit === 'year') {
        const m = s.match(/^P(\d+)Y$/i);
        if (m) return parseInt(m[1], 10);
        if (/^\d+$/.test(s)) return parseInt(s, 10);
        return 0;
    }
    if (unit === 'month') {
        if (/T/i.test(s)) return 0;
        const m = s.match(/^P(\d+)M$/i);
        if (m) return parseInt(m[1], 10);
        if (/^\d+$/.test(s)) return parseInt(s, 10);
        return 0;
    }
    if (unit === 'day') {
        const m = s.match(/^P(\d+)D$/i);
        if (m) return parseInt(m[1], 10);
        if (/^\d+$/.test(s)) return parseInt(s, 10);
        return 0;
    }
    return 0;
};

/** Canonical ISO 8601 duration for API storage (e.g. `10` -> `PT10M`). */
export const normalizeIsoDuration = (raw, unit) => {
    if (raw == null || raw === '') {
        return emptyIsoValue(unit);
    }
    const decoded = decodeIsoDuration(raw, unit);
    if (decoded === '' || decoded == null) {
        return emptyIsoValue(unit);
    }
    return encodeIsoDuration(decoded, unit);
};
